import { matchPath } from "react-router-dom";

/** Returns whether the current URL should highlight this menu item (supports nested routes). */
export function menuMatchesLocation(pathname, menuItem) {
  const hasExtraPaths =
    Array.isArray(menuItem.activeMatchPaths) && menuItem.activeMatchPaths.length > 0;
  const paths = hasExtraPaths ? menuItem.activeMatchPaths : [menuItem.path];
  // Strict per-pattern match when we list related routes (avoids /fish-data-graph matching /fish-data-graph-new).
  const exact = hasExtraPaths ? true : menuItem.exact === true;
  return paths.some((p) => matchPath(pathname, { path: p, exact }) != null);
}
